/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import IconVerified from 'components/icons/iconVerified';
import getShortCustomerName from 'commons/getShortCustomerName';
import ReviewStars from 'components/consumer/ReviewStars';
import cleanComment from 'commons/cleanComment';
import useScreen from 'hooks/useScreen';
import SanitizedHtml from 'components/consumer/SanitizedHtml';

const ReviewComponent = ({
  collapsible = false,
  date,
  full_name,
  keyId,
  location,
  maxWords = 40,
  rate,
  review,
}) => {
  const splittedReview = review.split(' ');

  const [isCollapsed, setIsCollapsed] = useState(
    !!(collapsible && splittedReview.length > maxWords)
  );

  const { isMobileOrTablet } = useScreen();

  if (!review) {
    return null;
  }

  const reviewToShow = isCollapsed
    ? `${splittedReview.slice(0, maxWords).join(' ')}...`
    : review;

  const rating = (
    <div
      key={`r${keyId}`}
      className="[&_svg]:relative [&_svg]:top-0.5 [&_svg]:max-[767px]:w-2.5 [&_span]:mr-[.3rem]"
    >
      <ReviewStars rating={parseInt(rate, 10)} readOnly size="sm" />
    </div>
  );

  return (
    <div
      key={keyId}
      className="flex px-0 py-6 [border-bottom:1px_solid_#f1f1f1] max-[767px]:flex-col"
    >
      <div className="flex-[0.28] max-[767px]:flex max-[767px]:flex-1 max-[767px]:flex-col max-[767px]:mb-4">
        {isMobileOrTablet ? (
          rating
        ) : (
          <div className="w-11 h-11 max-h-[3.75rem] text-2xl text-gray-light6 bg-gray-light8 rounded-full mr-4 mb-2 flex justify-center items-center">
            {full_name?.[0]}
          </div>
        )}
        <div className="PDPFabricReviewsUI__user-details">
          <div className="[&_svg]:ml-2 [&_svg_g]:stroke-[#107c8c] flex items-center justify-start">
            <h4 className="text-sm font-bold m-0">
              {getShortCustomerName(full_name)} <IconVerified />
            </h4>
          </div>
          <div className="text-xs">{location}</div>
        </div>
      </div>

      <div className="relative md:flex-[0.72]">
        {!isMobileOrTablet && (
          <div className="flex justify-between mb-4">{rating}</div>
        )}

        <div className="text-xs absolute top-1 right-0 max-[767px]:text-xs max-[767px]:-top-8">
          {format(new Date(date), 'MMM dd, yyyy')}
        </div>

        <SanitizedHtml className="text-xs" html={cleanComment(reviewToShow)} />

        {isCollapsed && (
          <span
            className="text-xs text-brand cursor-pointer hover:underline"
            onClick={() => setIsCollapsed(false)}
          >
            Continue Reading
          </span>
        )}
      </div>
    </div>
  );
};

ReviewComponent.propTypes = {
  collapsible: PropTypes.bool,
  date: PropTypes.string,
  full_name: PropTypes.string,
  keyId: PropTypes.string,
  location: PropTypes.string,
  maxWords: PropTypes.number,
  rate: PropTypes.number,
  review: PropTypes.string,
};
export default ReviewComponent;
